package org.example.project.screens_sys

import androidx.compose.runtime.*
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import org.example.project.dashboard.ScreenManager
import org.example.project.dashboard.TrackedScreenHost
import org.example.project.engineslot.SlotActionBarRow
import org.example.project.engineslot.SlotStyles
import org.example.project.manager.LumaticaApiManager
import org.example.project.screens_cus.CUSCeoDashboardStyles
import org.example.project.service.RollenService
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun SysWebseitenDashboard() {
    val screens = ScreenManager.childScreensForKey("WebseitenDashboard")
        .filter { RollenService.hasReadPermission(it.key) }
    var selectedKey by remember { mutableStateOf("") }
    val selected = screens.firstOrNull { it.key == selectedKey } ?: screens.firstOrNull()
    var metrics by remember { mutableStateOf<Map<String, String>>(emptyMap()) }

    LaunchedEffect(Unit) {
        runCatching {
            val root = Json.parseToJsonElement(LumaticaApiManager.call("webseitenuebersicht/metrics")).jsonObject
            val values = root["metrics"]?.jsonObject
            metrics = listOf("pageViews", "flyerDownloads", "visitsThisMonth", "visitsTotal")
                .associateWith { values?.get(it)?.jsonPrimitive?.content ?: "0" }
        }
    }

    Style(SlotStyles)
    Style(CUSCeoDashboardStyles)
    Div({ classes(SlotStyles.screenRoot) }) {
        Div({ style { padding(20.px); flexShrink(0); boxSizing("border-box") } }) {
            Div({ classes(CUSCeoDashboardStyles.tileScrollHost) }) {
                Div({ classes(CUSCeoDashboardStyles.grid); style {
                    gridTemplateColumns("repeat(4, 240px)"); property("width", "max-content"); property("margin", "0 auto")
                } }) {
                    listOf(
                        Triple("Webseitenaufrufe", "pageViews", "images/webseitenuebersicht.svg"),
                        Triple("Flyer geladen", "flyerDownloads", "images/download.svg"),
                        Triple("Besuche diesen Monat", "visitsThisMonth", "images/zeitfenster.svg"),
                        Triple("Besuche gesamt", "visitsTotal", "images/uebersicht.svg")
                    ).forEach { (label, field, icon) ->
                        Div({ classes(CUSCeoDashboardStyles.tile) }) {
                            Div({ classes(CUSCeoDashboardStyles.iconSlot) }) {
                                Img(src = icon, attrs = { classes(CUSCeoDashboardStyles.icon); attr("alt", "") })
                            }
                            Div({ classes(CUSCeoDashboardStyles.textColumn) }) {
                                Div({ classes(CUSCeoDashboardStyles.tileLabel) }) { Text(label) }
                                Div({ classes(CUSCeoDashboardStyles.value) }) { Text(metrics[field] ?: "…") }
                            }
                        }
                    }
                }
            }
        }
        SlotActionBarRow({}, {
            Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(12.px); flexWrap(FlexWrap.Wrap) } }) {
                screens.forEach { screen ->
                    LumaticaButton(screen.label, { selectedKey = screen.key }, variant = LumaticaButtonVariant.State, isActive = selected?.key == screen.key)
                }
            }
        }, {})
        Div({ style { width(100.percent); height(1.px); backgroundColor(Color("rgba(255,255,255,0.14)")); flexShrink(0) } })
        Div({ style { flex("1"); minHeight(0.px); overflow("hidden") } }) {
            if (selected == null) Text("Keine freigegebenen Bereiche vorhanden.")
            else key(selected.key) { TrackedScreenHost(selected) { selected.content?.invoke(selected) } }
        }
    }
}
